import type { ApiRunnerSplitPaneMessages } from '../types';

const messages: ApiRunnerSplitPaneMessages = {
  'apiRunnerSplitPane.request': '请求参数',
  'apiRunnerSplitPane.response': '返回响应',
  'apiRunnerSplitPane.vertical': '左右分屏',
  'apiRunnerSplitPane.horizontal': '上下分屏',
  'apiRunnerSplitPane.none': '不分屏',
} as const;

export default messages;
